import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Button from '../../../components/Button/Button';
import QuestionnaireFormField from '../QuestionnaireFormField/QuestionnaireFormField';
import StickyToolbar from '../../../components/StickyToolbar/StickyToolbar';

import './questionnaire-form.scss';
import QuestionnaireFormTabular from './QuestionnaireFormTabular';
import QuestionnaireFormTabularTrueFalse from './QuestionnaireFormTabularTrueFalse';

class QuestionnaireForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = { width: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        const { isValid, validateForm } = this.props;
        if (!isValid) {
            validateForm();
        }

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const {
            errors,
            handleSubmit,
            isValid,
            questions,
            values,
            assessmentLanguage,
            savePartialQuestionsLoading,
            questionType,
        } = this.props;
        const { width } = this.state;
        const activeQuestion = questions.find((question) => {
            const key = question.id;
            return !Object.prototype.hasOwnProperty.call(values, key) || Object.prototype.hasOwnProperty.call(errors, key);
        });
        const activeId = activeQuestion ? activeQuestion.id : null;
        let continueMsg = 'All questions must be answered to continue';
        let continu = questionType === 'MOST_LEAST' ? 'Submit' : 'Submit';
        return (
            <form className="questionnaire-form" noValidate onSubmit={handleSubmit}>
                {width > 1000 && questionType === 'TABULAR_AGREE' && (
                    <QuestionnaireFormTabular questions={questions} activeId={activeId} />
                )}
                {width > 1000 && questionType === 'TABULAR_TRUE_FALSE' && (
                    <QuestionnaireFormTabularTrueFalse questions={questions} />
                )}
                {questions.map(question => (
                    <QuestionnaireFormField
                        isActive={activeId === question.id}
                        key={question.id}
                        name={`${question.id}`}
                        {...question}
                        assessmentLanguage={assessmentLanguage}
                    />))}
                <StickyToolbar.Themed>
                    <React.Fragment>
                        <ReactTooltip />
                        <div
                            className="save-container"
                            data-tip={!isValid || activeId !== null ? continueMsg : undefined}
                        >
                            <Button
                                disabled={savePartialQuestionsLoading
                                    || !isValid || activeId !== null}
                                type="submit"
                            >
                                {continu}
                            </Button>
                        </div>
                    </React.Fragment>
                </StickyToolbar.Themed>
            </form>
        );
    }
}

QuestionnaireForm.propTypes = {
    errors: PropTypes.shape({}).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    resetForm: PropTypes.func.isRequired,
    setSubmitting: PropTypes.func.isRequired,
    values: PropTypes.shape({}).isRequired,
    assessmentLanguage: PropTypes.string.isRequired,
    savePartialQuestionsLoading: PropTypes.bool.isRequired,
    questionType: PropTypes.string.isRequired,
};

export default QuestionnaireForm;
